import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpertCalibrationList',
  templateUrl: './ExpertCalibrationList.component.html',
  styleUrls: ['./ExpertCalibrationList.component.scss']
})
export class ExpertCalibrationListComponent implements OnInit {
  page:number=0;
  Filter_Familly:string=''
  Filter_Area:string=''

  Procssing:boolean=false;

  modalRef_Delete: any;
  constructor(
    private ExpertCalibration_Service:ExpertCalibrationService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_ExpertCalibration:Array<ExpertCalibration_Interface>=[]
  Data_Seleted_Delete:ExpertCalibration_Interface=Empty_ExpertCalibration_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(20).subscribe(
      data=>{
        this.ReadData_ExpertCalibration()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
    
  }

  Change_Filter(){
    this.page=0
  }

  ReadData_ExpertCalibration(){
    this.Procssing=true

    this.ExpertCalibration_Service.GetRecord().subscribe(
      data=>{
        this.DataList_ExpertCalibration=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
        
      }
    )
  }


  Delete(item:ExpertCalibration_Interface){
    this.modalRef_Delete.hide()
    item.DeletingProccess=true
    this.ExpertCalibration_Service.DeleteExpertCalibration(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_ExpertCalibration()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
        
      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
